import React from 'react';
import { Button, Modal, ModalProps } from 'antd';
import './style.scss';
import ModalCloseIcon from '../../../assets/svg/modal-close-icon.svg';
import classNames from 'classnames';
import getFormatMessage from '../../../locales/get-format-message';
import ReactDOM from 'react-dom';
import warnImage from '../../../assets/images/warn-yellow.png';
import { AutoTooltip } from '../../../components/auto-tooltip';

interface IProps {
  readonly onClose?: () => void;
  readonly width?: string;
  readonly onOk?: () => Promise<boolean>;
  readonly oKText?: string | React.ReactNode;
  readonly cancelText?: string;
  readonly title?: React.ReactNode | string;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly footer?: React.ReactNode;
  readonly loading?: boolean;
  readonly maskClosable?: boolean;
  readonly okButtonProps?: ModalProps['okButtonProps'];
  readonly closable?: string;
  readonly disabled?: boolean;
  readonly onCancel?: () => void; // 有两个按钮 但是左侧按钮不使用onClose关闭方法
  readonly okTooltip?: string; // ok按钮hover提示
}

export const ModalWrap = (props: IProps) => {
  const onOk = async () => {
    if (props.onOk) {
      await props.onOk();
    }
  };

  const { loading, disabled } = props;
  const renderFooter = () => {
    const okClassName = classNames(
      'gc-btn',
      props?.okButtonProps?.danger ? '' : 'gc-btn-primary'
    );
    return (
      <div className="gc-modal-footer">
        <div className="col-right">
          {props.cancelText ? (
            <Button
              className="gc-btn gc-btn-default"
              onClick={props.onCancel || props.onClose}
            >
              {props.cancelText || getFormatMessage('cancel')}
            </Button>
          ) : null}
          {props.oKText ? (
            props.okTooltip ? (
              <AutoTooltip title={props.okTooltip} placement="bottom">
                <div>
                  {typeof props?.oKText === 'string' ? (
                    <Button
                      className={okClassName}
                      type="primary"
                      onClick={onOk}
                      loading={loading}
                      disabled={disabled ? disabled : false}
                      {...props.okButtonProps}
                    >
                      {props.oKText || getFormatMessage('save')}
                    </Button>
                  ) : (
                    props.oKText
                  )}
                </div>
              </AutoTooltip>
            ) : typeof props?.oKText === 'string' ? (
              <Button
                className={okClassName}
                type="primary"
                onClick={onOk}
                loading={loading}
                disabled={disabled ? disabled : false}
                {...props.okButtonProps}
              >
                {props.oKText || getFormatMessage('save')}
              </Button>
            ) : (
              props.oKText
            )
          ) : null}
        </div>
      </div>
    );
  };

  const classnames = classNames('modal-wrap', props.className);
  const closable = props.closable !== 'false';
  return (
    <Modal
      className={classnames}
      title={props.title}
      width={props.width || 434}
      open={true}
      onCancel={props.onClose}
      maskClosable={props.maskClosable || false}
      getContainer={false}
      centered={true}
      closable={closable}
      closeIcon={<img src={ModalCloseIcon} />}
      footer={props.footer || renderFooter()}
    >
      {props.children}
    </Modal>
  );
};

const showModal = (props: IProps, icon?: React.ReactNode) => {
  const id = `common-modal-${Math.random()}`;
  const container = document.createElement('div');
  container.id = id;
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.render(<></>, container);
    document.body.removeChild(container);
  };

  const onClose = async () => {
    await props.onClose?.();
    destroy();
  };

  const onOk = async () => {
    try {
      const res = await props.onOk?.();
      if ((props.onOk && res === true) || !props.onOk) {
        destroy();
      }
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const modalProps: IProps = {
    ...props,
    title: (
      <>
        {icon}
        <span>{props.title}</span>
      </>
    ),
    onOk,
    onClose,
  };

  ReactDOM.render(<ModalWrap {...modalProps} />, container);

  return { destroy };
};

ModalWrap.show = (props: IProps) => {
  return showModal(props);
};

ModalWrap.warn = (props: IProps) => {
  return showModal(
    props,
    <img
      src={warnImage}
      alt="Warning"
      style={{ marginRight: '10px', marginTop: '-2px' }}
    />
  );
};
